import { deepcopy, setValue } from "./utility.js";

export async function EmphasisTransformation(role, spec, original, specifier, action, option) {
  if (action === "add" && specifier.index === undefined && specifier["id"] === undefined) {
    let indexTo1, indexTo, indexTo2 = 0;
    if (option.index !== undefined) indexTo1 = option.index - 1;
    else indexTo1 = spec.emphasis.items.length;
    spec.emphasis.items.forEach((d, di) => {
      if (indexTo2 == indexTo1) indexTo = di;
      indexTo2++;
    });
    indexTo = indexTo || spec.emphasis.items.length;
    // make annotation item
    let emphItem = {}
    Object.keys(option).forEach(propertyKey => {
      if (!["index", "id", "role", "type"].includes(propertyKey)) {
        emphItem[propertyKey] = (option[propertyKey].constructor.name !== "Object" || option[propertyKey].constructor.name !== "Array" ? option[propertyKey] : (option[propertyKey]));
      } else if (propertyKey === "id") {
        emphItem["name"] = option["id"];
      }
    })
    spec.emphasis.items.splice(indexTo, 0, emphItem)
    // append it
  } else {
    let toRemove = [];
    let fcnt = 0;
    spec.emphasis.items.forEach((emphItem, ai) => {
      let flag = true;
      // filtering: index, text...
      if (flag) {
        if (specifier.index !== undefined && ai !== specifier.index) flag = false;
        if (specifier["id"] !== undefined) {
          if (specifier["id"].constructor.name === "Array") flag = specifier["id"].includes(emphItem.name);
          else flag = (specifier["id"] == emphItem.name);
        }
      }
      if (flag) {
        fcnt += 1;
        if (action === "remove") {
          // todo
          toRemove.push(ai);
        } else if (action === "modify" || action === "reposition") {
          // todo
          Object.keys(option).forEach(propertyKey => {
            let _propertyKey = { "angle": "rotate" }[propertyKey] || propertyKey;
            if (!["role"].includes(propertyKey)) {
              if (option[propertyKey].constructor.name === "Array") {
                if (option[propertyKey][fcnt - 1] !== null) emphItem = setValue(emphItem, _propertyKey, option[propertyKey][fcnt - 1])
                else delete emphItem[_propertyKey]
              }
              else {
                if (option[propertyKey] !== null) emphItem = setValue(emphItem, _propertyKey, option[propertyKey])
                else delete emphItem[_propertyKey]
              }
            }
          })
        } else if (action === "replace") {
          // todo
        } else if (action === "duplicate") {
          let indexTo = [], dup = [], dupItem;
          let fcnt = 0;
          spec.emphasis.items.forEach((emphItem, ei) => {
            if (emphItem.type === "mark") {
              if (specifier["id"] === undefined || (specifier["id"].constructor.name === "Array" && specifier["id"].includes(emphItem.name)) ||
                (specifier["id"].constructor.name === "String" && specifier["id"] === emphItem.name)) {
                indexTo.push(ei);
                dupItem = deepcopy(emphItem);
              }
            }
            if (dupItem) {
              fcnt += 1;
              if (option?.to) {
                Object.keys(option.to).forEach(propertyKey => {
                  if (!["role"].includes(propertyKey)) {
                    let _propertyKey = { "id": "name", "angle": "rotate" }[propertyKey] || propertyKey;
                    if (option.to[propertyKey].constructor.name === "Array") {
                      if (option.to[propertyKey][fcnt - 1] !== null) dupItem = setValue(dupItem, _propertyKey, option.to[propertyKey][fcnt - 1])
                      else delete dupItem[_propertyKey]
                    }
                    else {
                      if (option.to[propertyKey] !== null) dupItem = setValue(dupItem, _propertyKey, option.to[propertyKey])
                      else delete dupItem[_propertyKey]
                    }
                  }
                })
              } else {
                dupItem.name = dupItem.name + "_dup"
              }
              dup.push(dupItem)
            }
          });
          let dcnt = 0;;
          dup.forEach((dupItem, ei) => {
            spec.emphasis.items.splice(dcnt + indexTo[ei], 0, dupItem);
            dcnt++;
          })
        }
      }
    });
    if (spec.emphasis?.items?.length > 0) {
      spec.emphasis.items = spec.emphasis.items.filter((aitem, ai) => !toRemove.includes(ai));
    }
  }
  return spec;
}